import type { ReactNode } from "react";

export function highlightKeywords(
  text: string,
  keywords: readonly string[]
): ReactNode[] {
  if (keywords.length === 0) return [text];

  const pattern = new RegExp(
    `(${keywords.map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")})`,
    "gi"
  );
  const parts = text.split(pattern);

  return parts.map((part, index) => {
    const isMatch = keywords.some(
      (k) => k.toLowerCase() === part.toLowerCase()
    );
    if (!isMatch) return part;
    return (
      <span
        key={`${part}-${index}`}
        className="font-semibold text-[var(--charity-green-dark)]"
      >
        {part}
      </span>
    );
  });
}
